module.exports = __webpack_public_path__ + "static/media/dayDateHighlightDate.c7b9f571.svg";